import { useEffect, useState } from 'react';
import Select from 'react-select';
import agent from '../../../app/api/agent';

export default function WorkflowDynamicMetaDataDropdown({
  type,
  apiParamsDetails,
  // placeholder,
  value,
  onChangeHandler,
}: {
  type: string;
  apiParamsDetails: {
    templateId: string;
    elementTypeId: string;
    subTaskId?: string;
    id?: string;
  };
  value: string;
  placeholder?: string;
  onChangeHandler: (value: string) => void;
}) {
  // const { TemplateStore } = useStore();

  const [errorAndLoader, setErrorAndLoader] = useState({
    error: '',
    isLoading: true,
  });
  const [taskAndMetadatOptionsList, setTaskAndMetadatOptionsList] =
    useState<any>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setErrorAndLoader({
          error: '',
          isLoading: true,
        });
        /** ----------------------  Parent Dynamic metadata API --------------------------- */
        if (type === 'ParentDynamicmetadata') {
          let params: any = { ...apiParamsDetails };

          let result =
            await agent.MetaDataElementType.parentDynamicmetadataDetailsAPI(
              params,
            );
          let list = await taskOptionsHandler(result?.data || []);
          setTaskAndMetadatOptionsList(list);
        } else {
          /** ----------------------  Dynamic metadata API --------------------------- */
          let params: any = { ...apiParamsDetails };

          let result =
            await agent.MetaDataElementType.dynamicmetadataDetailsAPI(params);
          let list = await taskOptionsHandler(result?.data || []);
          setTaskAndMetadatOptionsList(list);
        }
        setErrorAndLoader({
          error: '',
          isLoading: false,
        });
      } catch {
        setErrorAndLoader({
          error: 'Something went wrong',
          isLoading: false,
        });
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, [apiParamsDetails]);

  const metadataOptionsHandler = async (
    metadata: {
      id: string;
      name: string;
    }[],
  ) => {
    return metadata?.map((data) => {
      return {
        id: data.id,
        value: `${data.name} ${data.id}`,
        label: `${data.name}`,
      };
    });
  };

  const elementHandler = async (elements: any) => {
    return elements?.flatMap(
      (element: { id: string; name: string; type: string }) => {
        return element?.type === 'Dynamicmetadata'
          ? []
          : {
              id: element.id,
              value: `${element.name} ${element.id}`,
              label: `${element.name}`,
            };
      },
    );
  };

  const taskOptionsHandler = async (tasks: any) => {
    try {
      let { taskSubtask, metadata } = tasks || {};
      let taskOptionList = [];

      for (let i = 0; i < taskSubtask?.length; i++) {
        taskOptionList.push({
          label: taskSubtask[i]?.taskSubtaskName || '',
          options: await elementHandler(taskSubtask[i].element),
        });
      }
      taskOptionList.push({
        label: 'metadata',
        options: await metadataOptionsHandler(metadata),
      });
      setErrorAndLoader({
        error: '',
        isLoading: false,
      });
      return taskOptionList;
    } catch {
      setErrorAndLoader({
        error: 'Something went wrong',
        isLoading: false,
      });
      return [];
    }
  };

  return (
    <Select
      value={{
        label: value?.split('|')?.[0],
        value: value?.split('|')?.[1],
      }}
      // onMenuClose={false}
      isLoading={errorAndLoader.isLoading}
      options={taskAndMetadatOptionsList}
      onChange={(data: any) => {
        onChangeHandler(`${data.label}|${data.id}`);
      }}
      blurInputOnSelect={false}
      className="dynamicMetadata-select"
    />
  );
}
